// Simple intl provider replacement - returns a function that formats messages
const getIntlProvider = () => ({
  formatMessage: ({ defaultMessage }) => defaultMessage || '',
});

export default getIntlProvider;
